<!-- Generated template for the MysportIconComponent component -->


<div #ref style="display: none;"></div>